/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type CartPriceTable_item$ref = any;
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type CartItemPricing_item$ref = any;
export type CartItemPricing_item = {
    readonly lastTransaction: {
        readonly isPrivateOffer: boolean | null;
        readonly mostRecentDealerOffer: {
            readonly isSubmitted: boolean | null;
            readonly totalAmount: {
                readonly convertedAmountList: ReadonlyArray<{
                    readonly currency: Currency | null;
                    readonly amount: number | null;
                } | null> | null;
            } | null;
        } | null;
    } | null;
    readonly cartPriceTableDisplayInfo: {
        readonly pricing: {
            readonly showSale: boolean | null;
            readonly showNet: boolean | null;
            readonly showRetail: boolean | null;
        } | null;
    } | null;
    readonly pricing: {
        readonly retailPrice: {
            readonly convertedAmountList: ReadonlyArray<{
                readonly amount: number | null;
                readonly currency: Currency | null;
            } | null> | null;
        } | null;
        readonly salePrice: {
            readonly convertedAmountList: ReadonlyArray<{
                readonly amount: number | null;
                readonly currency: Currency | null;
            } | null> | null;
        } | null;
        readonly netPrice: {
            readonly convertedAmountList: ReadonlyArray<{
                readonly amount: number | null;
                readonly currency: Currency | null;
            } | null> | null;
        } | null;
    } | null;
    readonly shipmentQuotes: ReadonlyArray<{
        readonly isComplimentary: boolean | null;
        readonly totalAmount: {
            readonly convertedAmountList: ReadonlyArray<{
                readonly currency: Currency | null;
                readonly amount: number | null;
            } | null> | null;
        } | null;
    } | null> | null;
    readonly " $fragmentRefs": CartPriceTable_item$ref;
    readonly " $refType": CartItemPricing_item$ref;
};



const node: ReaderFragment = (function () {
    var v0 = [
        ({
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userId"
        } as any)
    ], v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "currency",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "amount",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "totalAmount",
        "storageKey": null,
        "args": null,
        "concreteType": "FinancialAmount",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "convertedAmountList",
                "storageKey": null,
                "args": null,
                "concreteType": "ConvertedAmountList",
                "plural": true,
                "selections": [
                    (v1 /*: any*/),
                    (v2 /*: any*/)
                ]
            }
        ]
    } as any), v4 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "convertedAmountList",
            "storageKey": null,
            "args": null,
            "concreteType": "ConvertedAmountList",
            "plural": true,
            "selections": [
                (v2 /*: any*/),
                (v1 /*: any*/)
            ]
        } as any)
    ];
    return {
        "kind": "Fragment",
        "name": "CartItemPricing_item",
        "type": "Item",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "userId",
                "type": "String!"
            }
        ],
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "lastTransaction",
                "storageKey": null,
                "args": (v0 /*: any*/),
                "concreteType": "Transaction",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isPrivateOffer",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "mostRecentDealerOffer",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Offer",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "isSubmitted",
                                "args": null,
                                "storageKey": null
                            },
                            (v3 /*: any*/)
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": "cartPriceTableDisplayInfo",
                "name": "displayInfo",
                "storageKey": null,
                "args": (v0 /*: any*/),
                "concreteType": "ItemDisplayInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "pricing",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PriceInfoDisplay",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "showSale",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "showNet",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "showRetail",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "pricing",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemPricing",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "retailPrice",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "plural": false,
                        "selections": (v4 /*: any*/)
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "salePrice",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "plural": false,
                        "selections": (v4 /*: any*/)
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "netPrice",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "plural": false,
                        "selections": (v4 /*: any*/)
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "shipmentQuotes",
                "storageKey": null,
                "args": null,
                "concreteType": "ShipmentQuote",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isComplimentary",
                        "args": null,
                        "storageKey": null
                    },
                    (v3 /*: any*/)
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "CartPriceTable_item",
                "args": null
            }
        ]
    } as any;
})();
(node as any).hash = '26c42e081db3aaa9de372a63c1cb54c3';
export default node;
